import React from 'react';
import './Qualitymeets.css';
import dp3300img from '../../../imgs/qualitym.webp';

const Qualitymeets = () => {
  return (
    <div className="qualitymeets-container">
      <div className="text-content">
        <h1>Where Quality Meets Efficiency</h1>
        <p>
          Experience tangible improvements in your production process and efficiency through our proven solutions.
        </p>
      </div>
      <div className="image-content">
        <img src={dp3300img} alt="DP3300 Machine" />
      </div>
    </div>
  );
};

export default Qualitymeets;
